import React, { useState } from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import { deleteProspectCompany } from "../../../services/prospectCompany.service";
import { showSuccess, showError } from "../../../services/toast.service";

const Panel = ({ selectedIds = [], onDeleteSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  // Gérer la suppression des prospects d'entreprises sélectionnés
  const handleDelete = async () => {
    if (selectedIds.length === 0) return;
    
    setIsDeleting(true);
    
    try {
      // Supprimer chaque prospect d'entreprise sélectionné
      const deletePromises = selectedIds.map(id => deleteProspectCompany(id));
      await Promise.all(deletePromises);
      
      showSuccess(`${selectedIds.length} prospect(s) d'entreprise supprimé(s) avec succès`);
      
      // Notifier le composant parent pour mettre à jour la liste
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      showError(`Erreur lors de la suppression: ${error.message}`);
    } finally {
      setIsDeleting(false);
    }
  };

  // Ne pas afficher le panel si aucun prospect d'entreprise n'est sélectionné
  if (selectedIds.length === 0) {
    return null;
  }

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedIds.length} prospect(s) d'entreprise</span> sélectionné(s)
      </div>
      <button 
        className={cn("button", styles.button, { [styles.loading]: isDeleting })} 
        onClick={handleDelete}
        disabled={isDeleting}
      >
        {isDeleting ? 'Suppression...' : 'Supprimer'}
      </button>
    </div>
  );
};

export default Panel;
